declare const window: any;
namespace ajaxManager {
    /**
     * 请求多个并发ajax 并执行完成回调
     * @param  {any} arr
     * @param  {Function} callBackFunc
     */
    export function moreAjax(arr: any, callBackFunc: Function, failBackFunc?: Function) {
        if (Array.isArray(arr)) {
            window.axios.all(arr).then(window.axios.spread(function () {
                if (typeof (callBackFunc) == 'function') {
                    callBackFunc(arguments);//acct,perms,perms1,perms2,perms3  acct:any,perms:any,perms1:any,perms2:any,perms3:any
                }
            })).catch(function (error: any) {
                if (typeof (failBackFunc) == 'function') {
                    callBackFunc(arguments);//acct,perms,perms1,perms2,perms3  acct:any,perms:any,perms1:any,perms2:any,perms3:any
                } else if (typeof (callBackFunc) == 'function') {
                    callBackFunc(arguments);
                }
            });;
        }
    }
    export function deleteEmpty(_obj: any) {
        for (var key in _obj) {
            if (typeof (_obj[key]) == "object") {
                deleteEmpty(_obj[key]);
            }
            if (_obj[key] == null) {
                delete _obj[key];
            }
        }
    }
    export function deleteUndefinedStr(obj: any) {
        if (typeof (obj) == "object") {
            if (window.jQuery.isArray(obj)) {
                for (let i = 0; i < obj.length; i++) {
                    if (typeof (obj[i]) == "object") {
                        deleteUndefinedStr(obj[i]);
                    }
                }
            } else {
                for (let key in obj) {
                    if (typeof (obj[key]) == "object") {
                        deleteUndefinedStr(obj[key]);
                    } else {
                        if (obj[key] == "undefined") {
                            delete obj[key];
                        }
                    }
                }
            }
        }
    }
    /**
     * 处理ajax入参
     * @param ajaxData 
     */
    export function formatAiaxData(ajaxData: any) {
        let data: object = {};
        var newFormData = new FormData();
        if (ajaxData instanceof FormData) {
            ajaxData.forEach(function (e, v) {
                data[v] = e;
            })
        } else {
            data = ajaxData;
        }
        const formatTimerUnitFunc = function (_expData) {
            for (let key in _expData) {
                switch (_expData[key]) {
                    case '<时间戳>':
                        _expData[key] = Number(window.moment().format('x'));
                        break;
                    case '<时间戳-今天开始>':
                        _expData[key] = Number(window.moment((window.moment().format('YYYY-MM-DD') + ' 00:00:00')).format('x'));
                        break;
                    case '<时间戳-今天结束>':
                        _expData[key] = Number(window.moment((window.moment().format('YYYY-MM-DD') + ' 23:59:59')).format('x'));
                        break;
                    case '<时间戳-昨天开始>':
                        _expData[key] = Number(window.moment((window.moment().subtract('days', 1).format('YYYY-MM-DD') + ' 00:00:00')).format('x'));
                        break;
                    case '<时间戳-昨天结束>':
                        _expData[key] = Number(window.moment((window.moment().subtract('days', 1).format('YYYY-MM-DD') + ' 23:59:59')).format('x'));
                        break;
                    case '<时间戳-本周开始>':
                        let weekOfdayN = parseInt(window.moment().format('d')) // 计算今天是这周第几天 周日为一周中的第一天
                        let start = window.moment().subtract(weekOfdayN - 1, 'days').format('YYYY-MM-DD') // 周一日期
                        _expData[key] = Number(window.moment((start + ' 00:00:00')).format('x'));
                        break;
                    case '<时间戳-本周结束>':
                        let weekOfday = parseInt(window.moment().format('d')) // 计算今天是这周第几天 周日为一周中的第一天
                        let end = window.moment().add(7 - weekOfday, 'days').format('YYYY-MM-DD') // 周日日期
                        _expData[key] = Number(window.moment((end + ' 23:59:59')).format('x'));
                        break;
                    case '<时间戳-本月开始>':
                        let monthDayN = window.moment().add('month', 0).format('YYYY-MM') + '-01';
                        _expData[key] = Number(window.moment(window.moment(monthDayN).format('YYYY-MM-DD HH:mm:ss')).format('x'));
                        break;
                    case '<时间戳-本月结束>':
                        let monthDay = window.moment().add('month', 0).format('YYYY-MM') + '-01';
                        _expData[key] = Number(window.moment(window.moment(monthDay).add('month', 1).add('days', -1).format('YYYY-MM-DD HH:mm:ss')).format('x'));
                        break;
                    case '<时间戳-当年开始>':
                        _expData[key] = Number(window.moment().startOf('year').format('x'));
                        break;
                    case '<时间戳-当年结束>':
                        _expData[key] = Number(window.moment().endOf('year').format('x'));
                        break;
                    default:
                        _expData[key] = _expData[key];
                        break;
                }
            }
        };
        formatTimerUnitFunc(data);

        for (let ajaxKeyI in data) {
            if (data[ajaxKeyI] instanceof File) {
                continue;
            }
            if (typeof (data[ajaxKeyI]) == 'object') {
                if (!window.jQuery.isEmptyObject(data[ajaxKeyI])) {
                    if (!Array.isArray(data[ajaxKeyI])) {
                        formatTimerUnitFunc(data[ajaxKeyI]);
                    }
                }
            }
        }

        if (ajaxData instanceof FormData) {
            for (let akey in data) {
                if (data[akey]) {
                    newFormData.append(akey, data[akey])
                }
            }
            data = newFormData;
        }
        return data;
    }
    export function setAjaxConfig(ajaxConfig: any, callBackFunc?: Function, failBackFunc?: Function) {
        let authorization = window.NSUtils.OAuthCode.get();
        let isAllowSendNull = typeof (ajaxConfig.isAllowSendNull) == "boolean" ? ajaxConfig.isAllowSendNull : false;
        ajaxConfig.headers = typeof (ajaxConfig.headers) == 'object' ? ajaxConfig.headers : {};
        if (authorization == false) {
            /*if(typeof(window.NetstarApiConfig.loginUrl) == 'string'){
                const loginUrl = window.NetstarApiConfig.webRootPath + window.NetstarApiConfig.loginUrl;
                window.location = loginUrl;
            }else {
                window.NSUtils.OAuthCode.reLogin();
                return false;
            }*/
        } else {
            ajaxConfig.headers.authorization = authorization;
        }
        // 使用调试IP代理 读取本地存储中的ip地址
        if (window.NetstarApiConfig.isUsePreferRouterIps) {
            let preferRouterIps = window.store.get('NetstarPreferRouterIps');
            ajaxConfig.headers['prefer-router-ips'] = preferRouterIps;
        }

        if (typeof (window.NetstarMainPage) == 'object') {
            if (typeof (window.NetstarMainPage.systemInfo) == 'object') {
                if (typeof (window.NetstarMainPage.systemInfo.context) == 'object') {
                    if (window.NetstarMainPage.systemInfo.context.envType === 0) {
                        let NSDevServerRouter: any = window.store.get('NSDevServerRouter');
                        let NSDevServerState: any = window.store.get('NSDEVSERVERSTATE');//本地联调状态 1开启 0关闭
                        if (typeof (NSDevServerState) != 'number') {
                            NSDevServerState = 1;
                            window.store.set('NSDEVSERVERSTATE', 1);
                        }
                        if (typeof (NSDevServerRouter) == 'string') {
                            if (NSDevServerRouter && NSDevServerState === 1) {
                                ajaxConfig.headers['server-router'] = NSDevServerRouter;
                            }
                        }
                    }
                }
            }
        }
        if (ajaxConfig.src) {
            ajaxConfig.url = ajaxConfig.src;
        }
        if (ajaxConfig.url.indexOf('http') === -1) {
            if (ajaxConfig.isUseGetRootPath === false) {
                ajaxConfig.url = window.NSUtils.getUrl({ urlType: "web", suffix: ajaxConfig.url });
            } else {
                ajaxConfig.url = window.NSUtils.getUrl({ urlType: "api", suffix: ajaxConfig.url });
            }
            // ajaxConfig.url = window.NSUtils.getUrl()+ajaxConfig.url;
        }
        if (typeof (window.NetstarHomePage) == 'object') {
            if (window.NetstarHomePage.version === 'v4') {
                if (ajaxConfig.url.indexOf('/middleware/') > -1) {
                    let middlewareRootPath = window.NetstarApiConfig.middlewareRootPath;
                    const urlParaObj = window.NSUtils.getUrlPara();
                    if (urlParaObj.nsmidwareserver) {
                        middlewareRootPath = urlParaObj.nsmidwareserver;//如果浏览器指定了地址优先读取浏览器指定的
                    }
                    if (middlewareRootPath.indexOf('middleware/') > -1) {
                        middlewareRootPath = middlewareRootPath.replace('middleware/', '');
                    }
                    ajaxConfig.url = ajaxConfig.url.replace(window.NSUtils.getUrl() + '/', middlewareRootPath);
                    ajaxConfig.url = ajaxConfig.url.replace(window.NSUtils.getUrl(), middlewareRootPath);
                }
            }
        }
        ajaxConfig.data = typeof (ajaxConfig.data) == 'object' ? ajaxConfig.data : {};
        ajaxConfig.proxy = typeof (ajaxConfig.proxy) == 'object' ? ajaxConfig.proxy : {};
        ajaxConfig.proxy.callBackFunc = callBackFunc;
        ajaxConfig.proxy.failBackFunc = failBackFunc;
        ajaxConfig.proxy.ajaxAfterHandler = ajaxConfig.ajaxAfterHandler;
        ajaxConfig.proxy.ajaxUrl = ajaxConfig.url;
        if (typeof (ajaxConfig.plusData) == 'object') {
            ajaxConfig.proxy.plusData = ajaxConfig.plusData;
        }
        ajaxConfig.contentType = ajaxConfig.contentType ? ajaxConfig.contentType : 'application/json; charset=utf-8';
        if (ajaxConfig.contentType == 'application/json') {
            ajaxConfig.contentType = 'application/json; charset=utf-8';
        }
        let ajaxDataObj: any = {};
        if (window.jQuery.isArray(ajaxConfig.data)) {
            ajaxDataObj = ajaxConfig.data;
        } else {
            ajaxDataObj = formatAiaxData(ajaxConfig.data);
        }
        deleteUndefinedStr(ajaxDataObj); // 删除 undefined字符串
        if (isAllowSendNull === false) {
            deleteEmpty(ajaxDataObj);
        }
        ajaxConfig.data = ajaxDataObj;

        ajaxConfig.method = ajaxConfig.method ? ajaxConfig.method : ajaxConfig.type;
        if (typeof (ajaxConfig.method) == 'undefined') { ajaxConfig.method = 'GET'; }
        if (ajaxConfig.method.toLocaleLowerCase() == 'get') {
            ajaxConfig.data.Authorization = authorization;
            ajaxConfig.params = ajaxConfig.data;
        }
        if (ajaxConfig.data.Authorization === false) {
            delete ajaxConfig.data.Authorization;
        }
        if (ajaxConfig.contentType) {
            ajaxConfig.headers['Content-Type'] = ajaxConfig.contentType;
            if (ajaxConfig.contentType == 'application/json; charset=utf-8') {
                ajaxConfig.data = JSON.stringify(ajaxConfig.data);
            }
        }
        if (ajaxConfig.method.toLocaleLowerCase() == 'post' && ajaxConfig.contentType == 'application/x-www-form-urlencoded') {
            ajaxConfig.transformRequest = [function (data: any) {
                // 对 data 进行任意转换处理
                let ret = '';
                for (let it in data) {
                    ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
                }
                ret = ret.substring(0, ret.lastIndexOf('&'));
                return ret;
            }];
        }

        if (ajaxConfig.ajaxBeforeHandler) {
            let ajaxBeforeHandler = ajaxConfig.ajaxBeforeHandler;
            if (typeof (ajaxBeforeHandler) == 'string') {
                ajaxBeforeHandler = window.NSUtils.getFunction(ajaxConfig.ajaxBeforeHandler);
            }
            if (typeof (ajaxBeforeHandler) == "function") {
                let _ajaxConfig = ajaxBeforeHandler(ajaxConfig);
                if (_ajaxConfig === false) {
                    return false
                }
                if (_ajaxConfig && _ajaxConfig.url) {
                    ajaxConfig = _ajaxConfig;
                }
            }
        }
        // 处理url '/netstarApiId{id}'  start --
        let rex = /\/netstarApiId\{(.*?)\}/;
        let urlStr = ajaxConfig.url;
        let matchArr = urlStr.match(rex);
        if (matchArr != null) {
            let netstarApiId = matchArr[1];
            let rexStr = matchArr[0];
            urlStr = urlStr.replace(rexStr, '');
            ajaxConfig.url = urlStr;
            ajaxConfig.headers['netstar-api-id'] = netstarApiId;
        }
        // 处理url '/netstarApiId{id}'  end --



        delete ajaxConfig.contentType;
        if (typeof (ajaxConfig.headers['netstar-api-log']) == 'object') {
            ajaxConfig.headers['netstar-api-log'] = JSON.stringify(ajaxConfig.headers['netstar-api-log']);
        }
        if (ajaxConfig.headers['netstar-api-log']) {
            ajaxConfig.headers['netstar-api-log'] = window.NetStarUtils.base64Safe.encode(ajaxConfig.headers['netstar-api-log']);
        }//sjj 20220211 操作日志中文转码
    }
    /**
     * @param  {any} ajaxConfig
     * @param  {Function} successFunc
     */
    export function ajax(ajaxConfig: any, callBackFunc: Function, failBackFunc: Function) {
        let sendAjaxConfig = window.NSUtils.deepCopy(ajaxConfig);
        if (ajaxConfig.data instanceof FormData) {
            sendAjaxConfig.data = ajaxConfig.data;
        }
        let isAjax = setAjaxConfig(sendAjaxConfig, callBackFunc, failBackFunc);
        //ajax前置时返回false 不执行接口
        if (isAjax === false) {
            return false
        }
        //在setAjaxConfig中处理了FormData数据
        // if(ajaxConfig.contentType === 'multipart/form-data'){
        //     sendAjaxConfig.data = ajaxConfig.data;
        // }
        // 验证ajax.data 配置是否完整 lyw 2022/10/27  start---------------
        if (sendAjaxConfig.validAjaxDataRequired) {
            let ajaxDataIsSuccess = validAjaxDataRequired(sendAjaxConfig);
            if (!ajaxDataIsSuccess) {
                console.warn("发送ajax失败，请检查发送参数是否完整", sendAjaxConfig);
                setTimeout(function () {
                    callBackFunc({
                        success: true,
                        data: {},
                        rows: [],
                    }, sendAjaxConfig);
                }, 100)
                return;
            }
        }
        // 验证ajax.data 配置是否完整 lyw 2022/10/27  end---------------
        /*********yl 20230605 判断是否读前端数据库数据******start*/
        if (typeof window.NSWebDatabase == "function" && typeof window.NetstarApiConfig == "object" && window.NetstarApiConfig.cacheDatabase) {
            if (typeof window.nsWebDatabase == "undefined") {
                window.nsWebDatabase = new window.NSWebDatabase()
            }
            return window.nsWebDatabase.getDataByAjaxConifg(ajaxConfig).then(result => {
                if (result.success) {
                    if (typeof window.NetStarUtils == "object" && window.NetStarUtils.OAuthCode.get()) {
                        let plusDataOptions: any = { plusData: {} };
                        if (typeof (ajaxConfig.plusData) == 'object') {
                            plusDataOptions.plusData = ajaxConfig.plusData;
                        }
                        return callBackFunc(result, plusDataOptions);
                    }
                } else {
                    if (result.msg) {
                        console.error(result.msg);
                    }
                    return ajaxFunc(ajaxConfig, sendAjaxConfig, failBackFunc);
                }
            }).catch(e => {
                return ajaxFunc(ajaxConfig, sendAjaxConfig, failBackFunc);
            });
        }
        /*********yl 20230605 判断是否读前端数据库数据******end*/
        return ajaxFunc(ajaxConfig, sendAjaxConfig, failBackFunc);
    }


    export function ajaxFunc(ajaxConfig, sendAjaxConfig, failBackFunc) {
        sendAjaxConfig.timeout = typeof (sendAjaxConfig.timeout) == 'number' ? sendAjaxConfig.timeout : 30 * 1000;//30毫秒
        // dc aes加密
        if (typeof (window.aesjs) == "object" && window.aesjs.needEncrypt(ajaxConfig)) {
            window.aesjs.encrypt(sendAjaxConfig);
            if (sendAjaxConfig.headers && sendAjaxConfig.headers) {
                sendAjaxConfig.headers["Content-Type"] = "text/plain";
                delete sendAjaxConfig.transformRequest;
            }
        }
        return window.axios(sendAjaxConfig, { timeout: sendAjaxConfig.timeout }).then(function (response: any) {
            // aes 解密
            if (typeof (window.aesjs) == "object" && window.aesjs.needEncrypt(ajaxConfig)) {
                const aesUtil = new window.aesjs.AesUtil();
                response.data = aesUtil.decrypt(response.data);
            }
            let resData = typeof (response.data) == 'object' ? response.data : {};
            if (response.status >= 200 && response.status < 300) {
                if (response.headers['content-type'] === 'text/html' || response.headers['content-type'] == "text/html; charset=utf-8") {
                    resData = {
                        success: true,
                        dataType: 'html',
                        data: response.data
                    };
                }
                //200代表返回值正常
                if (typeof (response.config.proxy.ajaxAfterHandler) == 'string') {
                    let ajaxAfterHandler = window.NSUtils.getFunction(response.config.proxy.ajaxAfterHandler);
                    if (typeof (ajaxAfterHandler) == "function") {
                        let _data = ajaxAfterHandler(response.data, response.config);
                        if (_data) {
                            resData = _data;
                        }
                    }
                } else if (typeof (response.config.proxy.ajaxAfterHandler) == 'function') {
                    let _data = response.config.proxy.ajaxAfterHandler(response.data, response.config);
                    if (_data) {
                        resData = _data;
                    }
                }
                let plusObj: any = {};
                if (response.config) {
                    if (typeof (response.config.proxy) == 'object') {
                        if (typeof (response.config.proxy.plusData) == 'object') {
                            plusObj = response.config.proxy.plusData;
                        }
                    }
                }
                //let isMultiAjax:boolean = typeof(plusObj.isMultiAjax)=='boolean' ? plusObj.isMultiAjax : false;
                //有logFileName弹出提示点击提示可以查看详情，但比如getByID返回false,看弹出错误也应该有回调才对，不给回调是因为怕弹出提示语重复
                //所以写了个bug,需要修正 logFileName需要是一个可以请求的json，比如1.json
                /*if(resData.logFileName && resData.success === false && (isMultiAjax === false)){
                    //sjj  弹出错误日志
                    if(typeof(plusObj.controllerObj)=='object'){
                        resData['NETSTAR-URL'] = plusObj.controllerObj.url;
                    }
                    window.nsAlert(resData.msg,'error');
                    window.toastr.remove();
                    let nstoastrError =  new window.NSToastr(resData.msg,resData,'error');
                    nstoastrError.timer = 5000;//60000
                    nstoastrError.show();
                    if(typeof(plusObj.removeDisabledFunc)=='function'){
                        plusObj.removeDisabledFunc(plusObj);
                    }
                }*/
                /*********yl 20230605 判断是否存数据到前端数据库******start*/
                if (typeof window.NSWebDatabase == "function" && typeof window.NetstarApiConfig == "object" && window.NetstarApiConfig.cacheDatabase) {
                    if (typeof window.nsWebDatabase == "undefined") {
                        window.nsWebDatabase = new window.NSWebDatabase()
                    }
                    if (typeof (window.NSValsIsEqual) == 'undefined') {
                        var $nsscript = window.$('nsscript[src="/web/dist/ns-vals-is-equal/index.js"]');
                        var nsscriptVersion = '';
                        if ($nsscript.length == 1) {
                            nsscriptVersion = $nsscript.attr('v');
                        }
                        window.require.config({
                            baseUrl: "/web/dist/",
                            paths: {
                                "NSValsIsEqual": "ns-vals-is-equal/index",
                            },
                            urlArgs: function (id, url) {
                                let args = 'v=' + window.moment().format('x');
                                if (nsscriptVersion) {
                                    args = 'v=' + nsscriptVersion;
                                }
                                return (url.indexOf('?') === -1 ? '?' : '&') + args;
                            }
                        });
                        window.require(['NSValsIsEqual'], function () {
                            window.NSValsIsEqual = arguments[0];
                        });
                    }
                    //校验参数是否全等
                    if (window.nsWebDatabase.tableVersion && ajaxConfig.headers && ajaxConfig.headers["netstar-api-id"]) {
                        let apiId = ajaxConfig.headers["netstar-api-id"];
                        window.nsWebDatabase.getTableConfig();
                        let tableConfig = window.nsWebDatabase.tableVersion[apiId];
                        if (tableConfig) {
                            if (!tableConfig.params || window.NSValsIsEqual.compare(tableConfig.params, response.config.data)) {
                                if (resData && resData.rows) {
                                    window.nsWebDatabase.saveDataByAjaxConifg(ajaxConfig, resData.rows).then(result => {
                                        if (!result.success) {
                                            console.log(result)
                                        } else {
                                            console.log("存储成功")
                                        }
                                    })
                                } else {
                                    console.log("数据格式错误,数据字段不是rows，或者不存在rows")
                                }
                            }
                        }
                    }
                }
                /*********yl 20230605 判断是否存数据到前端数据库******end*/

                if (typeof (response.config.proxy.callBackFunc) == 'function') {
                    let plusDataOptions: any = { plusData: {} };
                    if (typeof (response.config.proxy.plusData) == 'object') {
                        plusDataOptions.plusData = response.config.proxy.plusData;
                    }

                    /*******NetstarApiConfig 添加回调方法，需求：如果返回错误信息为：该帐号没有此路径权限时，提示退出登录（蓝月亮项目）start*******/
                    let ajaxAfterCommonCallback;
                    if(typeof(window.NetstarApiConfig.ajaxAfterCommonCallback) == 'function'){
                        ajaxAfterCommonCallback = window.NetstarApiConfig.ajaxAfterCommonCallback
                    }
                    if(typeof(ajaxAfterCommonCallback) == 'function'){
                        ajaxAfterCommonCallback(resData, function(_res){
                            if(_res == false){
                                return response.config.proxy.callBackFunc(resData, plusDataOptions);
                            }
                        })
                    }else{
                        return response.config.proxy.callBackFunc(resData, plusDataOptions);
                    }
                    /*******NetstarApiConfig 添加回调方法，需求：如果返回错误信息为：该帐号没有此路径权限时，提示退出登录（蓝月亮项目）end*******/
                } else {
                    if (typeof (plusObj.removeDisabledFunc) == 'function') {
                        plusObj.removeDisabledFunc(plusObj);
                    }
                }
                if (window.jQuery.isArray(resData.midwareInfos)) {
                    if (resData.midwareInfos.length > 0) {
                        let pushSessionObj = {
                            url: response.config.proxy.ajaxUrl.split('?')[0],
                            midwareInfos: resData.midwareInfos,
                            logFileName: resData.logFileName,
                        };
                        let storeNSAjaxStr = window.sessionStorage.getItem('NSAJAXCONFIG');
                        if (storeNSAjaxStr) {
                            try {
                                let nsajaxArray = JSON.parse(storeNSAjaxStr);
                                if (!window.jQuery.isArray(nsajaxArray)) {
                                    nsajaxArray = [];
                                }
                                //如果当前的是已经缓存的值，执行替换操作
                                let isExistPushAjaxI = -1;
                                for (let ajaxSessionI = 0; ajaxSessionI < nsajaxArray.length; ajaxSessionI++) {
                                    if (nsajaxArray[ajaxSessionI].url === pushSessionObj.url) {
                                        isExistPushAjaxI = ajaxSessionI;
                                        break;
                                    }
                                }
                                if (isExistPushAjaxI > -1) {
                                    nsajaxArray.splice(isExistPushAjaxI, 1, pushSessionObj);//替换
                                } else {
                                    if (nsajaxArray.length < 10) {
                                        nsajaxArray.unshift(pushSessionObj);//不满10个可以继续追加
                                    } else if (nsajaxArray.length === 10) {
                                        nsajaxArray.splice(0, 1);//当前缓存已经存储10个
                                        nsajaxArray.unshift(pushSessionObj);//不满10个可以继续追加
                                    }
                                }
                                window.sessionStorage.setItem('NSAJAXCONFIG', JSON.stringify(nsajaxArray));
                            } catch (errorStoreAJAX) {

                            }
                        } else {
                            let nsajaxArray = [];
                            nsajaxArray.unshift(pushSessionObj);//不满10个可以继续追加
                            window.sessionStorage.setItem('NSAJAXCONFIG', JSON.stringify(nsajaxArray));
                        }
                    }
                }
            } else {
                console.warn(response);
            }
        }).catch(function (error: any) {
            console.error(error);
            let resData: any = {};
            if (error.response && error.response.status === 501 && resData.success === false) {
                //501返回
                if (typeof (error.response.config.proxy.callBackFunc) == 'function') {
                    let plusDataOptions: any = { plusData: {} };
                    if (typeof (error.response.config.proxy.plusData) == 'object') {
                        plusDataOptions.plusData = error.response.config.proxy.plusData;
                    }
                    resData.success = true;
                    resData.status = error.response.status;
                    error.response.config.proxy.callBackFunc(resData, plusDataOptions);
                }
                return;
            } else if (error.response && error.response.status == 403) {
                //403错误 延迟30秒触发
                let plusDataObj: any = {};
                let proxyObj: any = {};
                if (error.config && error.config.proxy) {
                    proxyObj = error.config.proxy;
                }
                plusDataObj = typeof (proxyObj.plusData) == 'object' ? proxyObj.plusData : {};
                if (plusDataObj.disabledDomId) {
                    let $curBtn = window.jQuery('#' + plusDataObj.disabledDomId);
                    $curBtn.addClass('pt-timer-interval');
                    //let tempTimerInter:any;
                    //let originalSpanHtml = $curBtn.children('span').html();
                    // let updateInterval:Function = function(){
                    //     let timerIntervalSecond = 30;//30秒
                    //     tempTimerInter = setInterval(function(){
                    //         timerIntervalSecond--;
                    //         let spanHtml = '请等待'+timerIntervalSecond+'秒';
                    //         $curBtn.children('span').html(spanHtml);
                    //         if(timerIntervalSecond === 0){
                    //             clearInterval(tempTimerInter);
                    //             $curBtn.children('span').html(originalSpanHtml);
                    //             $curBtn.removeAttr('disabled');
                    //             $curBtn.removeClass('pt-timer-interval');
                    //             let errorObj:any = {success:false};
                    //             if(typeof(proxyObj.failBackFunc)=='function'){
                    //                 failBackFunc(errorObj,plusDataObj);
                    //             }
                    //         }
                    //     },1000)
                    // };
                    //updateInterval();
                } else {
                    console.warn(error.config);
                }
                return;
            }
            if (typeof (error.config) == 'undefined') {
                return;
            }
            if (error.response && error.response.data) {
                resData = error.response.data;
            }
            if (typeof (error.response) == 'undefined') {
                window.nsalert('服务器无响应，请检查网络连接情况', 'error');
                if (typeof (failBackFunc) == 'function') {
                    failBackFunc({ success: false }, {});
                }
                return;
            }
            if (error.response && typeof (error.response.headers['content-type']) != 'string') {
                error.response.headers['content-type'] = '';
            }
            if (error.response && error.response.headers['content-type'].indexOf('text/html') !== -1) {
                let htmlStr = window.NSUtils.htmlCode.getTagHtml('h1', error.response.data);
                if (htmlStr === '') {
                    htmlStr = window.language.ajaxErrorMsg.unknown;
                }
                let nsResponseError = new window.NSToastr(htmlStr, {}, 'error');
                nsResponseError.show();
                let errorObj: any = error.response && error.response.data ? error.response.data : { success: false };
                if (typeof (failBackFunc) == 'function') {
                    let tempObj: any = {};
                    if (error.response && error.response.config) {
                        if (error.response.config.proxy.plusData) {
                            tempObj = error.response.config.proxy.plusData;
                        }
                    }
                    failBackFunc(errorObj, tempObj);
                }
            } else {
                let errorObj: any = error.response && error.response.data ? error.response.data : { success: false };
                if (typeof (failBackFunc) == 'function') {
                    let tempObj: any = {};
                    if (error.response && error.response.config) {
                        if (error.response.config.proxy.plusData) {
                            tempObj = error.response.config.proxy.plusData;
                        }
                    }
                    failBackFunc(errorObj, tempObj);
                } else {
                    if (errorObj.msg) {
                        window.nsalert(errorObj.msg, 'error');
                    } else {
                        window.NSUtils.defaultAjaxError(errorObj, null);
                    }
                }
            }
        });

    }

    /**
     * ajax error
     * @param error 
     */
    export function defaultAjaxError(error: any, callBackFunc: Function | null) {
        let ajaxErrorInfos = window.NSAJAXERRORINFO.detail;
        let isDetail = false;
        let defaultErrorMsg = {};
        if (typeof (window.NetstarApiConfig) == "object") {
            if (window.NSAJAXERRORINFO[window.NetstarApiConfig.errorInfoMode]) {
                isDetail = window.NetstarApiConfig.errorInfoMode == "detail";
                ajaxErrorInfos = window.NSAJAXERRORINFO[window.NetstarApiConfig.errorInfoMode];
            }
            if (!window.jQuery.isEmptyObject(window.NetstarApiConfig.defaultErrorMsg)) {
                defaultErrorMsg = window.NetstarApiConfig.defaultErrorMsg;
            }
        }
        const nAjaxErrorInfos = window.NetStarUtils.getI18n(ajaxErrorInfos);
        if(!window.jQuery.isEmptyObject(nAjaxErrorInfos)){
            ajaxErrorInfos = nAjaxErrorInfos;
        }
        const i18n = window.NetStarUtils.getI18n(window.NetStarUtils.I18n);
        let errorinfo = typeof (ajaxErrorInfos[error.status]) == "string" ? ajaxErrorInfos[error.status] : ajaxErrorInfos.default;
        if (defaultErrorMsg[error.status]) {
            errorinfo = defaultErrorMsg[error.status];
        }
        if (isDetail) {
            let msgStr = error.msg;
            if (typeof (msgStr) == 'string') {
                if (msgStr.length > 40) {
                    msgStr = msgStr.substring(0, 40);
                }
                errorinfo = window.NetStarUtils.getI18nTipsStr(i18n.ajaxRequestError, { errorMsg: msgStr });
            } else {
                if (error.status) {
                    errorinfo = window.NetStarUtils.getI18nTipsStr(i18n.ajaxRequestError2, { errorState: error.status, errorInfo: errorinfo });
                } else {
                    errorinfo = window.NetStarUtils.getI18nTipsStr(i18n.ajaxRequestError3, { errorState: error.status });
                }
            }
        }
        if (typeof (callBackFunc) == "function") {
            callBackFunc(errorinfo);
        } else {
            console.error(errorinfo);
            let nsResponseError = new window.NSToastr(errorinfo, {}, 'error');
            nsResponseError.show();
        }
    }

    export function logAjax(ajaxData?: any) {
        if (typeof (window.NSSystemConfig) == 'object') {
            if (typeof (window.NSSystemConfig.logs) == 'object') {
                let ajaxConfig: any = typeof (window.NSSystemConfig.logs.ajax) === 'object' ? window.NSSystemConfig.logs.ajax : {};
                if (!window.jQuery.isEmptyObject(ajaxConfig)) {
                    if (typeof (window.NSSystemConfig.logs.expression) == 'object') {
                        if (window.NSSystemConfig.logs.expression.exportXls) {
                            ajaxConfig.headers = typeof (ajaxConfig.headers) == 'object' ? ajaxConfig.headers : {};
                            ajaxConfig.headers['netstar-api-log'] = { content: window.NSUtils.htmlCode.getRegularHtml(ajaxData, window.NSSystemConfig.logs.expression.exportXls) };//配置了操作日志 
                        }
                    }
                    window.NSUtils.ajax(ajaxConfig, function (res: any) {
                        res = typeof (res) == 'object' ? res : {};
                        let msgStr: string = res.msg ? res.msg : '';
                        console.warn(msgStr);
                    }, function (errorRes: any) {
                        errorRes = typeof (errorRes) == 'object' ? errorRes : {};
                        let msgStr: string = errorRes.msg ? errorRes.msg : '';
                        console.warn(msgStr);
                    })
                }
            }
        }
    }//操作日志ajax

    function validAjaxDataRequired(ajaxConfig) {
        let ajaxDataIsSuccess = true;
        if (ajaxConfig.validAjaxDataRequired) {
            switch (ajaxConfig.validAjaxDataRequired) {
                case "emptyObject":
                    if (ajaxConfig.data == "{}" || (typeof (ajaxConfig.data) == "object" && window.$.isEmptyObject(ajaxConfig.data))) {
                        ajaxDataIsSuccess = false;
                    }
                    break;
                case "emptyString":
                    if (ajaxConfig.data === "") {
                        ajaxDataIsSuccess = false;
                    }
                    break;
                default:
                    let validAjaxDataRequiredFields = ajaxConfig.validAjaxDataRequired.split(",");
                    let validAjaxDataRequiredFieldObj = {};
                    for (let vI = 0; vI < validAjaxDataRequiredFields.length; vI++) {
                        validAjaxDataRequiredFieldObj[validAjaxDataRequiredFields[vI]] = '{' + validAjaxDataRequiredFields[vI] + '}';
                    }
                    if (window.$.isEmptyObject(validAjaxDataRequiredFieldObj)) {
                        break;
                    }
                    let sendAjaxData = ajaxConfig.data;
                    if (typeof (sendAjaxData) == "string") {
                        try {
                            sendAjaxData = JSON.parse(sendAjaxData);
                        } catch (error) {
                            console.error("ajaxData验证失败原因：", error);
                        }
                    }
                    if (typeof (sendAjaxData) != "object") {
                        ajaxDataIsSuccess = false;
                        break;
                    }
                    let validAjaxDataRequiredFieldData = window.NetStarUtils.getFormatParameterJSON(validAjaxDataRequiredFieldObj, sendAjaxData);
                    for (let key in validAjaxDataRequiredFieldData) {
                        if (validAjaxDataRequiredFieldData[key] === null) {
                            ajaxDataIsSuccess = false;
                            break;
                        }
                    }
                    break;
            }
        }
        return ajaxDataIsSuccess;
    }
}
export default ajaxManager;